<template>
  <button
    class="btn btn-transparent btn-icon btn-xs"
    @click="increaseScale"
  >
    <i class="fal fa-plus" />
  </button>
</template>

<script>
import { useWebcamRecorder } from './use-webcam-recorder'

export default {
  name: 'WebcamRecorderIncreaseScaleButton',
  setup() {
    const { webcamScale } = useWebcamRecorder()

    const increaseScale = () => {
      webcamScale.value = webcamScale.value + 0.1
    }

    return {
      increaseScale,
    }
  },
}
</script>

<style scoped>

</style>
